import { render, staticRenderFns } from "./ClientSearch.vue?vue&type=template&id=31fbd15c&scoped=true"
import script from "./ClientSearch.vue?vue&type=script&lang=js"
export * from "./ClientSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fbd15c",
  null
  
)

export default component.exports